import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import H2 from 'UIComponents/elements/headings/H2';
import UIButton from 'UIComponents/button/UIButton';
import UIDialogBody from 'UIComponents/dialog/UIDialogBody';
import UIDialogCloseButton from 'UIComponents/dialog/UIDialogCloseButton';
import UIDialogFooter from 'UIComponents/dialog/UIDialogFooter';
import UIDialogHeader from 'UIComponents/dialog/UIDialogHeader';
import UIModal from 'UIComponents/dialog/UIModal';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import DefaultReviewRenderer from '../DefaultReviewRenderer';
export default function BaseReviewModal(_ref) {
  let {
    review,
    ReviewRenderer = DefaultReviewRenderer,
    title,
    form,
    onConfirm,
    onClose,
    confirmButtonText = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.modal.confirm"
    }),
    confirmButtonDataId,
    cancelButtonText = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "marketplace-ui-reviews.modal.cancel"
    }),
    cancelButtonDataId,
    confirmDisabled = false,
    tooltip,
    width = 800,
    catalogServices
  } = _ref,
      rest = _objectWithoutPropertiesLoose(_ref, ["review", "ReviewRenderer", "title", "form", "onConfirm", "onClose", "confirmButtonText", "confirmButtonDataId", "cancelButtonText", "cancelButtonDataId", "confirmDisabled", "tooltip", "width", "catalogServices"]);

  return /*#__PURE__*/_jsxs(UIModal, Object.assign({}, rest, {
    "data-test-id": "base-review-modal",
    width: width,
    children: [/*#__PURE__*/_jsxs(UIDialogHeader, {
      children: [/*#__PURE__*/_jsx(UIDialogCloseButton, {
        onClick: onClose
      }), /*#__PURE__*/_jsx(H2, {
        children: title
      })]
    }), /*#__PURE__*/_jsxs(UIDialogBody, {
      children: [form, /*#__PURE__*/_jsx(ReviewRenderer, {
        catalogServices: catalogServices,
        review: review
      })]
    }), /*#__PURE__*/_jsxs(UIDialogFooter, {
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: !confirmDisabled || !tooltip,
        title: tooltip,
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": confirmButtonDataId,
          use: "primary",
          disabled: confirmDisabled,
          onClick: onConfirm,
          children: confirmButtonText
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-test-id": cancelButtonDataId,
        use: "secondary",
        onClick: onClose,
        children: cancelButtonText
      })]
    })]
  }));
}